import { Link } from "@tanstack/react-router";
import { useState } from "react";
import { RichTextRenderer } from "~/components/RichTextRenderer";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "~/components/ui/accordion";
import { buttonVariants } from "~/components/ui/button";
import { cn } from "~/lib/utils";

interface FaqSectionProps {
  title: string;
  description?: string;
  showButton?: boolean;
  buttonLabel?: string;
  buttonLink?: string;
  items: Array<{ title: string; description: string }>;
}

export function FaqSection({
  title,
  description,
  showButton = true,
  buttonLabel,
  buttonLink,
  items,
}: FaqSectionProps) {
  const [accordionValue, setAccordionValue] = useState<string[]>([]);

  return (
    <section className="grid grid-cols-1 sm:grid-cols-2 gap-12">
      <div className="col-span-1">
        <h2 className="text-5xl font-medium mb-5">{title}</h2>
        <div className="flex flex-col gap-4">
          {description && <RichTextRenderer richText={description} />}
          {showButton && (
            <Link
              to={buttonLink ?? "/"}
              className={cn(
                buttonVariants({
                  variant: "outline",
                  size: "default",
                  className: "w-fit border-2",
                })
              )}
            >
              {buttonLabel ?? "Kontakt"}
            </Link>
          )}
        </div>
      </div>
      <div className="col-span-1">
        <Accordion
          value={accordionValue}
          onValueChange={setAccordionValue}
          type="multiple"
        >
          {items.map((item, index) => {
            const value = `item-${index + 1}`;

            return (
              <AccordionItem key={value} value={value}>
                <AccordionTrigger variant="light">
                  {item.title}
                </AccordionTrigger>
                <AccordionContent>
                  <RichTextRenderer richText={item.description} />
                </AccordionContent>
              </AccordionItem>
            );
          })}
        </Accordion>
      </div>
    </section>
  );
}
